import React from "react";
import axios from "axios";
import { WarningCircle } from "@phosphor-icons/react";
import {toast} from "react-toastify";

const AddressInput = ({
    address,
    postal_code,
    city,
    state,
    onChange,
    errors,
    setButtonDisabled
}) => {
    const handlePostalCodeChange = async (e) => {
        const value = e.target.value;
        onChange("postal_code", value);

        if (value.length === 6) {
            // Assuming Indian pincode
            try {
                const response = await axios.get(
                    `https://api.postalpincode.in/pincode/${value}`,
                );
                const data = response.data;

                if (data && data[0].Status === "Success") {
                    // Make Next enable for Wrong Postal Code
                    setButtonDisabled(false);
                    const postOffice = data[0].PostOffice[0];
                    onChange("city", postOffice.District);
                    onChange("state", postOffice.State);
                } else {
                    toast.error("Invalid Pincode or no data found")
                    // Make Next disable for Wrong Postal Code
                    setButtonDisabled(true);
                    console.error("Invalid Pincode or no data found");
                    onChange("city", "");
                    onChange("state", "");
                }
            } catch (error) {
                console.error("Error fetching city/state:", error);
                onChange("city", "");
                onChange("state", "");
            }
        } else {
            onChange("city", "");
            onChange("state", "");
        }
    };

    return (
        <div className="input-group border-b-[1.5px] py-3 h-[260px]">
            <label className="block text-sm">Address</label>
            <textarea
                value={address}
                onChange={(e) => onChange("address", e.target.value)}
                placeholder="Enter address"
                rows={4}
                className="mt-1 block w-[95%] p-2 border-[1.5px] border-gray-300 rounded-md"
            />{" "}
            {errors.address && (
                <span className="text-[#E47186] text-xs flex items-center gap-1">
                    <WarningCircle className="text-sm" />
                    {errors.address}
                </span>
            )}
            <label className="block text-sm mt-4">Postal Code</label>
            <input
                type="text"
                value={postal_code}
                onChange={handlePostalCodeChange}
                placeholder="Enter postal code of your hotel location"
                className="mt-1 block w-[95%] p-2 border-[1.5px] border-gray-300 rounded-md"
            />{" "}
            {errors.postal_code && (
                <span className="text-[#E47186] text-xs flex items-center gap-1">
                    <WarningCircle className="text-sm" />
                    {errors.postal_code}
                </span>
            )}
        </div>
    );
};

export default AddressInput;
